<template>
  <div class="tw:border-b tw:border-default-200">
    <EdroneInput
      type="default"
      class="tw:p-3"
      focused
      :value="searchQuery"
      :placeholder="trans._menu.searchBar.placeholder"
      unique-id="search-bar-input"
      @input="(value) => $emit('input', value)"
    >
      <template #icon>
        <FontAwesomeIcon icon="fa-light fa-magnifying-glass" />
      </template>
    </EdroneInput>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import EdroneInput from "edrone-components/EdroneInput.vue";

interface Props {
  searchQuery: string;
}

interface Emits {
  input: [query: string];
}

defineEmits<Emits>();
defineProps<Props>();
</script>
